/**
 * Installment rules — advanced: N(amount) only (no global min); common: price ÷ min.
 */
(function () {
  /**
   * Advanced list: first tier must use N(amount); following bare N inherit last amount.
   * @param {string} raw
   * @returns {{ tiers: { n: number, minUnits: number }[], hasAllowedList: boolean }}
   */
  function parseAdvancedAllowedCounts(raw) {
    if (!raw || !String(raw).trim()) {
      return { tiers: [], hasAllowedList: false };
    }

    const str = String(raw).replace(/\s/g, '');
    let tierMin = null;
    /** @type {{ n: number, minUnits: number }[]} */
    const tiers = [];

    for (const part of str.split(',')) {
      const token = part.trim();
      if (!token) continue;

      const parenMatch = token.match(/^(\d+)\((\d+(?:\.\d+)?)\)$/);
      let n;
      let minUnits;

      if (parenMatch) {
        n = parseInt(parenMatch[1], 10);
        minUnits = parseFloat(parenMatch[2]);
        tierMin = minUnits;
      } else {
        if (tierMin === null) continue;
        n = parseInt(token, 10);
        minUnits = tierMin;
      }

      if (Number.isInteger(n) && n >= 1 && !Number.isNaN(minUnits) && minUnits > 0) {
        tiers.push({ n, minUnits });
      }
    }

    return { tiers, hasAllowedList: tiers.length > 0 };
  }

  /**
   * @param {number} totalCents
   * @param {{ globalMinUnits?: number, maxInstallments?: number, allowedRaw?: string, ruleMode?: string }} options
   * @returns {{ count: number, value: number }}
   */
  function resolveInstallments(totalCents, options) {
    const globalMinUnits = Number(options.globalMinUnits) || 100;
    const maxInstallments = Number(options.maxInstallments) || 12;
    let ruleMode = options.ruleMode;
    const allowedRawSetting = options.allowedRaw ?? '';
    if (!ruleMode || ruleMode === '') {
      ruleMode = String(allowedRawSetting).trim() ? 'advanced' : 'common';
    }

    if (ruleMode === 'advanced') {
      const parsed = parseAdvancedAllowedCounts(allowedRawSetting);
      if (parsed.hasAllowedList) {
        let best = 0;
        for (const { n, minUnits } of parsed.tiers) {
          if (n > maxInstallments) continue;
          const minCents = Math.round(minUnits * 100);
          const minOrder = n * minCents;
          if (totalCents >= minOrder && n > best) {
            best = n;
          }
        }
        if (best >= 2) {
          return { count: best, value: Math.round(totalCents / best) };
        }
      }
      return { count: 0, value: 0 };
    }

    const minInstallmentValue = globalMinUnits * 100;
    let count = Math.floor(totalCents / minInstallmentValue);
    if (count > maxInstallments) count = maxInstallments;
    if (count < 2) {
      return { count: 0, value: 0 };
    }
    return { count, value: Math.round(totalCents / count) };
  }

  window.MadesaInstallmentRules = {
    parseAdvancedAllowedCounts,
    resolveInstallments,
  };
})();
